import Request from 'utilities/Request';
import isUndefined from 'lodash/isUndefined';

const fetchValuesForColumnByCard = (
  cardId,
  {column, dataSourceIds, search, limit, dateRangeFilter}
) => {
  const url = global.ENV.public
    ? `/cards/kpi/${cardId}/columns/values`
    : `/api/content/v2/analyzer/cards/${cardId}/values`;
  return Request.put(url, {
    column,
    search,
    queryOverrides: {
      limit,
      dateRangeFilter,
      overrideDateRange: isUndefined(dateRangeFilter) ? undefined : true,
    },
    dataSourceId: dataSourceIds[0],
  });
};

const fetchValuesForColumnByPage = (
  pageId,
  {column, dataSourceIds, search, limit}
) =>
  Request.put(`/api/content/v2/analyzer/stacks/${pageId}/values`, {
    column,
    search,
    limit,
    dataSourceIds,
  });

const fetchValuesForColumnByDataSource = (
  cardId,
  {column, dataSourceIds, search, limit}
) => {
  const url = global.ENV.public
    ? `/cards/${cardId}/datasources/values`
    : `/api/content/v3/cards/kpi/values`;

  return Request.put(url, {
    column,
    search,
    dataProvider: {
      dataSourceId: dataSourceIds[0],
    },
    queryOverrides: {
      limit,
    },
  });
};

export const fetchValuesForColumn = ({cardId, pageId, isDomoApp, ...rest}) => {
  if (!pageId && !cardId) {
    throw Error('pageId or cardId is required to fetch values');
  }

  // /v2/analyzer/cards doesn't support DomoApps. Query using the datasource
  if (isDomoApp) {
    return fetchValuesForColumnByDataSource(cardId, rest);
  }

  return cardId
    ? fetchValuesForColumnByCard(cardId, rest)
    : fetchValuesForColumnByPage(pageId, rest);
};

export const fetchDataSourcesByCardId = cardId =>
  global.ENV.public
    ? Request.get(`/cards/${cardId}/datasources`)
    : Request.get(`/api/content/v1/datasources/cards/${cardId}`);
